import _ from 'lodash';
import React, { Component } from 'react';
import classNames from 'classnames';
import { canViewAccounting } from '../../utils/RoutingUtils';
import { connect } from 'react-redux';
import AccountingForm from './components/AccountingForm.js';
import { showToast } from '../../actions/Actions.js';
import '../../css/CommonTheme.css';

class Accounting extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { pathname } = this.props.history.location;
        return (
            <div className="applicationWrapper">
                <div className="secondaryNav">
                    {canViewAccounting && (
                        <button
                            className={classNames({
                                secondaryNavLink: true,
                                secondaryNavActiveLink: pathname === '/accounting',
                            })}
                            onClick={() => this.props.history.push('accounting')}
                        >
                            Accounting Form
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}
const mapDispatchToProps = {
    showToast,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Accounting);
